import { FULL_INGREDIENTS, INGREDIENTS, QUALITY } from "../data/product";
import Accordion from "./Accordion";
import { Reveal } from "./Reveal";

export default function InsideFormula() {
  return (
    <section id="formula" data-testid="inside-formula" className="bg-[#FDFCF9] border-y border-ink/8 py-20 md:py-28 px-6 md:px-10">
      <div className="mx-auto max-w-[1240px]">
        <Reveal>
          <p className="eyebrow text-center">What&apos;s inside</p>
          <h2 className="font-display text-4xl md:text-5xl text-ink mt-3 text-center leading-tight">
            Benefits &amp; highlighted ingredients
          </h2>
          <p className="mt-5 font-light text-[15px] text-ink/70 text-center max-w-[62ch] mx-auto leading-relaxed">
            Vivoré Luxe Hydrating Cream is a rich body moisturizer designed to hydrate dry
            skin, support the moisture barrier, and leave skin feeling softer and smoother —
            lightly scented with mango, peach, and apricot.
          </p>
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {INGREDIENTS.map((ing, i) => (
            <Reveal key={ing.name} delay={(i % 2) * 0.08}>
              <div
                data-testid={`ingredient-card-${i}`}
                className="h-full bg-[#F8F5F2] border border-ink/8 rounded-[22px] p-7 flex gap-5 items-start transition-all duration-700 hover:shadow-[0_24px_50px_rgba(60,45,30,0.09)] hover:-translate-y-0.5"
              >
                <span className="w-11 h-11 rounded-full bg-lavsoft flex items-center justify-center shrink-0">
                  <ing.icon size={17} strokeWidth={1.6} className="text-lavdeep" />
                </span>
                <div>
                  <h3 className="font-display text-xl text-ink leading-snug">{ing.name}</h3>
                  <p className="mt-2 font-light text-sm leading-relaxed text-ink/70">{ing.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            {QUALITY.map((q) => (
              <span
                key={q.label}
                data-testid="quality-badges"
                className="flex items-center gap-2 bg-[#F8F5F2] border border-ink/10 rounded-full px-5 py-2.5"
              >
                <q.icon size={13} strokeWidth={1.6} className="text-lavdeep" />
                <span className="font-sans text-[10.5px] uppercase tracking-wide2 text-ink/80">{q.label}</span>
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-12 mx-auto max-w-[860px]">
            <h3 className="font-display text-2xl md:text-3xl text-ink text-center">Full ingredient list</h3>
            <p className="mt-2 font-light text-[13px] text-stone text-center">
              Everything in the jar, plainly listed.
            </p>
            <div className="mt-8 bg-[#F8F5F2] border border-ink/8 rounded-[22px] px-7 md:px-9 py-2">
              <Accordion
                items={[
                  {
                    q: "View the full ingredient list",
                    a: `${FULL_INGREDIENTS} — Matches the current manufacturer-approved label. External use only; avoid contact with eyes; keep out of reach of children.`,
                  },
                ]}
                testPrefix="ingredients"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
